import { Box, Stack } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import { FC } from 'react'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'

interface DeleteShiftDialogProps {
	open: boolean
	title: string
	description: string
	onClose: () => void
	onConfirm: () => void
	isLoading?: boolean
}

export const DeleteShiftDialog: FC<DeleteShiftDialogProps> = ({
	open,
	title,
	description,
	onClose,
	onConfirm,
	isLoading = false,
}) => {
	if (!open) return <></>

	return (
		<Box>
			<Dialog
				open={open}
				onClose={onClose}
				scroll='body'
				PaperProps={{
					sx: {
						width: '682px',
						maxWidth: 'calc(100vw - 32px)',
						borderRadius: '12px',
						m: 0,
					},
				}}
			>
				<Stack
					sx={{
						pt: '32px',
						pb: '32px',
						px: '24px',
						gap: '24px',
					}}
				>
					<TypographyHeader align='center'>{title}</TypographyHeader>
					<TypographyPrimary align='center'>{description}</TypographyPrimary>
					<Stack direction='row' gap='24px' justifyContent='space-between'>
						<OutlinedButton
							disableRipple
							width='100%'
							disabled={isLoading}
							sx={{
								color: COLORS.main,
								border: `1px solid ${COLORS.shadowMainColor}`,
								'&:hover': {
									color: 'white',
									border: `1px solid ${COLORS.shadowMainColor}`,
									boxShadow: 'none',
								},
							}}
							onClick={onClose}
						>
							Отмена
						</OutlinedButton>
						<OutlinedButton
							disableRipple
							width='100%'
							disabled={isLoading}
							sx={{
								color: COLORS.error,
								backgroundColor: 'white',
								border: `1px solid ${COLORS.error}`,
								'&:hover': {
									backgroundColor: COLORS.error,
									opacity: 0.9,
									border: `1px solid ${COLORS.error}`,
									boxShadow: 'none',
								},
							}}
							onClick={onConfirm}
						>
							Удалить
						</OutlinedButton>
					</Stack>
				</Stack>
			</Dialog>
		</Box>
	)
}
